export default "__VITE_ASSET__DdLXezjN__"